import { FETCH_CONDITION_START, FETCH_CONDITION_SUCCESS, FETCH_CONDITION_FAIL } from '../actions/actionTypes';

const initialState = {
    verification: {
        success: false,
        loading: false,
        error: null
    },
    confirmEmail: {
        success: false,
        loading: false,
        error: null
    },
    logout: {
        success: false,
        loading: false,
        error: null
    },
    userPreference: {
        data: null,
        loading: false,
        error: null
    },
    userUpdate: {
        success: false,
        loading: false,
        error: null
    },
    signup: {
        success: false,
        loading: false,
        error: null
    },
    setPassword: {
        success: false,
        loading: false,
        error: null
    },
    resetPassword: {
        success: false,
        loading: false,
        error: null
    },
    password: {
        success: false,
        loading: false,
        error: null
    },
    addCartItem: {
        success: false,
        loading: false,
        error: null
    },
    updateCartItem: {
        success: false,
        loading: false,
        error: null
    },
    removeCartItem: {
        success: false,
        loading: false,
        error: null
    },
    clearCart: {
        success: false,
        loading: false,
        error: null
    },
    removeVoucher: {
        success: false,
        loading: false,
        error: null
    },
    deleteDirectDebit: {
        success: false,
        loading: false,
        error: null
    },
};

/* * * * * * * * * * * * * * * * * * * * * * * * *
* METHODS THAT UPDATE STATES WITH CORRECT VALUES *
* * * * * * * * * * * * * * * * * * * * * * * *  */
const fetchConditionStart = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        loading: true
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

const fetchConditionSuccess = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        success: action.value,
        loading: false,
        error: null
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

const fetchConditionFail = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        success: false,
        loading: false,
        error: action.error
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

/* * * * * * * * *
* REDUCER METHOD *
* * * * * * * *  */
// Depending on the active action type, execute the correct function to update the correct states with the correct values
// Pass two parameters, first is the old state values, second is the new state values, these are passed from actions
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CONDITION_START: return fetchConditionStart(state, action);
        case FETCH_CONDITION_SUCCESS: return fetchConditionSuccess(state, action);
        case FETCH_CONDITION_FAIL: return fetchConditionFail(state, action);
        default: return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/condition.js